import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/authSlice";

export const useSidenavControllers = () => {
  const user = useSelector(selectUser);

  const role: "company" | "individual" =
    user?.account_type === "company" ? "company" : "individual";

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  return { user, role, showLogoutModal, setShowLogoutModal };
};
